import { render } from "./GoogleAutoComplete.vue?vue&type=template&id=53b4612a"
import script from "./GoogleAutoComplete.vue?vue&type=script&lang=js"
export * from "./GoogleAutoComplete.vue?vue&type=script&lang=js"

import "./GoogleAutoComplete.vue?vue&type=style&index=0&id=53b4612a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__